import React from 'react';
import { Container, Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, CardHeader } from 'reactstrap'
import Header from '../../Componentes/header'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Nav from './Componentes/aspiranteNav'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'


export default class AspiranteInicio extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            usuarioAsignado: '',
            documentos: [
                { nombre: 'Solicitud de inscripción', ref: null },
                { nombre: 'Acta de nacimiento', ref: null },
                { nombre: 'CURP', ref: null },
                { nombre: 'Fotografía', ref: null },
                { nombre: 'Comprobante de pago de inscripción', ref: null },
                { nombre: 'Certificado de bachillerato (En caso de no contar con ello, deberás subir la carta compromiso)', ref: null },
                { nombre: 'Formato FMM', ref: null },
                { nombre: 'Contrato estudiantil', ref: null },
                { nombre: 'Número de seguro social', ref: null },
                // { nombre: 'Certificado parcial de licenciatura', ref: null },
                // { nombre: 'Certificado de licenciatura', ref: null },
                // { nombre: 'Dictamen de revalidación o equivalencia de estudios', ref: null }
            ],
            isViewOpen: null
        }

        this.referenciar = this.referenciar.bind(this)
        this.toggleDescription = this.toggleDescription.bind(this)
        this.estado = this.estado.bind(this)
    }

    componentDidMount() {
        Fetch('/api/getAspirantePerfil', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ curp: sessionStorage.getItem('curp') })
        })
            .then(response => {
                this.referenciar(response.data)
                console.log(response.data)
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados')
                        break;

                    case 605:
                        toast.info('No existen coincidencias')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })

        Fetch('/api/getUsuarioAsignado', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ficha: sessionStorage.getItem('ficha') })
        })
            .then(response => {
                this.setState({ usuarioAsignado: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados' + err)
                        break;

                    case 605:
                        toast.info('No existen coincidencias')
                        break;

                    default:
                        toast.error("Se produjo un error de conexion " + err)
                        break;
                }
            })
    }

    referenciar(perfil) {
        var doc = this.state.documentos;

        doc[0].ref = perfil.solicitud;
        doc[1].ref = perfil.acta_nacimiento;
        doc[2].ref = perfil.acta_curp;
        doc[3].ref = perfil.fotografia;
        doc[4].ref = perfil.comprobante_pago;
        doc[5].ref = perfil.certificado_bachillerato;
        doc[6].ref = perfil.forma_extranjero;
        doc[7].ref = perfil.contrato_estudiantil;
        doc[8].ref = perfil.nss;
        // doc[9].ref = perfil.certificado_parcial_licenciatura;
        // doc[10].ref = perfil.certificado_licenciatura;
        // doc[11].ref = perfil.dictamen_revalidacion;

        this.setState({ documentos: doc })
    }

    toggleDescription(obj) {
        this.setState(prevState => ({
            isViewOpen: obj >= 0 ? obj : null
        })
        )
    }

    estado(e) {
        switch (e) {
            case 'VACIO':
                return <div className="d-inline-block text-secondary">Documento sin registrar</div>

            case 'REVISION':
                return <div className="d-inline-block text-warning">Documento en revision</div>

            case 'ACEPTADO':
                return <div className="d-inline-block text-success">Documento aceptado!</div>

            case 'RECHAZADO':
                return <div className="d-inline-block text-danger">Documento rechazado</div>

            default:
                break;
        }
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                <Col className="bg-light" lg="3">
                        <Nav nombre_completo={sessionStorage.getItem('nombre') + " " + sessionStorage.getItem('ap_paterno') + " " + sessionStorage.getItem('ap_materno')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>

                                    <p className="font-italic text-justify p-3 mt-3" style={{ backgroundColor: '#a8b5ff' }}>
                                        Si tienes alguna duda con respecto a algún documento, puedes comunicarte vía correo electrónico con el revisor asignado: <div className="d-inline-block font-weight-bold" onClick={() => document.execCommand("copy")} >{this.state.usuarioAsignado}</div>, y en un horario hábil de 8:00 AM a 8:00 PM te contestaran.
                                    </p>
                                    
                                    <Card className="p-4 mt-4 mb-4">

                                        <Row>
                                            {this.state.documentos[0].ref !== null ? this.state.documentos.map((value, index) => (
                                                ((sessionStorage.getItem('nacionalidad') === 'E') && (index === 6) || (index !== 6)) ? (
                                                    index !== 4 ? (
                                                    <Col xs="12" md="6" lg="4">
                                                        <Card className="w-100 mt-3" style={{ height: '12rem' }} /* onClick={()=>this.toggleDescription(index)} */>
                                                            <CardHeader>{value.nombre}{value.ref.tipo === 'REQUERIDO' ? <div className="d-inline-block text-danger font-weight-bold">*</div> : ''}</CardHeader>
                                                            <CardBody className="text-center">
                                                                <div className="font-weight-bold d-inline-block text-left"> Estado </div> {this.estado(value.ref.estado)}
                                                                {value.ref.notificacion !== null ? <div className="d-inline-block text-justify">{value.ref.notificacion}</div> : ''}
                                                            </CardBody>
                                                        </Card>
                                                    </Col>) : '' ) : ''
                                            )) : 'VACIO'}
                                        </Row>

                                    </Card>

                                    <Modal className="pt-5 modal-lg " isOpen={this.state.isViewOpen !== null} toggle={() => this.toggleDescription()}>
                                        <ModalHeader toggle={() => this.toggleDescription()} className="font-weight-bold">{this.state.isViewOpen !== null ? this.state.documentos[this.state.isViewOpen].nombre : ''}</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col>
                                                    <Card className="border-0">
                                                        <Row>

                                                        </Row>

                                                    </Card>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}